import React from 'react';

const STATUS_CONFIG = {
  healthy: { color: 'bg-emerald-500', label: 'Healthy' },
  degraded: { color: 'bg-amber-500', label: 'Degraded' },
  unhealthy: { color: 'bg-red-500', label: 'Unhealthy' },
  unknown: { color: 'bg-gray-400', label: 'Unknown' },
};

export default function StatusIndicator({ status, showLabel = false, pulse = false }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.unknown;

  return (
    <span className="inline-flex items-center gap-1.5" title={config.label}>
      <span className="relative flex h-2.5 w-2.5">
        {pulse && status === 'degraded' && (
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${config.color} opacity-75`} />
        )}
        <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${config.color}`} />
      </span>
      {showLabel && (
        <span className="text-xs text-gray-600">{config.label}</span>
      )}
    </span>
  );
}
